import * as React from 'react';

import {Stack} from 'shells/layout/stack/stack';
import {TextField} from 'shells/textfield/textfield';
import {Body} from 'shells/typography/body';

import styles from './value-fields.module.css';

type Props = {
    quantity: string;
    price: string;
    discountPercentage: string;
    total: number;
    currencySymbol: string;
    onChangeQuantity: (arg1: string) => void;
    onChangePrice: (arg1: string) => void;
    onChangeDiscount: (arg1: string) => void;
};

export function ValueFields(props: Props) {
    return (
        <Stack isHorizontal={true} spacing={16} alignItems='center'>
            <div className={styles['value-field-small']}>
                <Body size='small' color='dark'>
                    Qty.
                </Body>
                <TextField
                    size='small'
                    type='number'
                    min='0'
                    value={props.quantity}
                    onChange={props.onChangeQuantity}
                    focusOnMount={true}
                />
            </div>
            <div className={styles['value-field']}>
                <Body size='small' color='dark'>
                    Price
                </Body>
                <TextField size='small' value={props.price} onChange={props.onChangePrice} />
            </div>
            <div className={styles['value-field']}>
                <Body size='small' color='dark'>
                    Discount
                </Body>
                <div className={styles['input-with-suffix']}>
                    <TextField
                        size='small'
                        value={props.discountPercentage}
                        onChange={props.onChangeDiscount}
                    />
                    <div className={styles.suffix}>%</div>
                </div>
            </div>
            <Stack spacing={8}>
                <Body size='small' color='dark'>
                    Total
                </Body>
                <div className={styles['total-value']}>
                    <Body size='small'>
                        {props.currencySymbol}
                        {props.total.toLocaleString(undefined, {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                        })}
                    </Body>
                </div>
            </Stack>
        </Stack>
    );
}
